import { ClientAnalytics } from './clientAnalytics'

export type GuideId =
  | 'using_ai'
  | 'analytical_workflow'
  | 'home_assignments'
  | 'xp_lab_feedback'
  | 'job_readiness'

type HomeEvent =
  | 'home:hero:primary_cta_click'
  | 'home:hero:login_cta_click'
  | 'home:go_deeper:card_click'
  | 'home:manifesto_teaser:cta_click'
  | 'home:testimonials:category_click'
  | 'home:testimonials:card_expand'
  | 'home:testimonials:card_collapse'
  | 'home:testimonials:linkedin_click'
  | 'home:testimonials:scroll_arrow_click'

type AboutEvent =
  | 'about:team:linkedin_click'
  | 'about:contact:email_click'
  | 'about:manifesto:primary_cta_click'

type GuideEvent =
  | 'guide:cta:click'
  | 'guide:related_link:click'

export type MarketingAnalyticsEvent =
  | HomeEvent
  | AboutEvent
  | GuideEvent

export function trackMarketing(
  event: MarketingAnalyticsEvent,
  properties?: Record<string, unknown>
) {
  ClientAnalytics.track(event, properties)
}
